export const DEFAULT_PROJECT = "8016017";
export const DEFAULT_MAX_COUNTER = 50;

export const normalizeLac = (lac) => {
  if (!Array.isArray(lac)) return null;
  const list = lac.map(x => (x ?? "").trim()).filter(Boolean);
  return list.length ? [...new Set(list)].sort() : null;
};